import { useMutation, useQueryClient } from 'react-query'
import ApiClient from '@quiqupltd/quiqupjs/lib/network/api-client'
import { useTracking } from './useTracking'
import { useEnvVars } from './useEnvVars'

type SubmitReturnItem = {
  sku: string
  quantity: number
}

type SubmitReturnPayload = {
  items: SubmitReturnItem[]
  reason_code: string
  sub_reason_code?: string
  customer_notes?: string
}

type SubmitReturnResponse = {
  id: string
  status: string
  created_at: string
}

type UseSubmitReturnOptions = {
  onSuccess?: (data: SubmitReturnResponse) => void
  onError?: (error: Error) => void
}

export function useSubmitReturn({
  onSuccess,
  onError,
}: UseSubmitReturnOptions = {}) {
  const { orderDetails } = useTracking()
  const { env } = useEnvVars()
  const queryClient = useQueryClient()
  const clientOrderId = orderDetails?.id

  return useMutation({
    mutationFn: (payload: SubmitReturnPayload) => {
      if (!clientOrderId) {
        return Promise.reject(new Error('Missing order ID'))
      }
      return ApiClient.post({
        path: `${env.QUIQUP_PLATFORM_URL}/api/return-requests/${clientOrderId}/submit`,
        includeAuth: false,
        data: payload,
      })
    },
    onSuccess: (data: SubmitReturnResponse) => {
      queryClient.invalidateQueries(['return-eligibility', clientOrderId])
      onSuccess?.(data)
    },
    onError,
  })
}
